import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {
    allInvestmentOfferTypes,
    investmentOfferCities,
    investmentOfferCountries,
    investmentOfferHolidayTypes,
    InvestmentOfferTypeSlug
} from "../constants/investment_offer_constants";

export const useInvestmentOfferListBreadcrumbs = () => {
    const categories = useSelector((state: IRPStore) => state.investmentOffer.categories);

    const {category, subcategory} = categories;

    const matchedCategoryObject = category && allInvestmentOfferTypes.find((type) => type.slug === category);
    const matchedSubcategoryObject =
        subcategory && [...investmentOfferCities, ...investmentOfferHolidayTypes, ...investmentOfferCountries].find((type) => type.slug === subcategory);

    return [
        {
            key: "pod-inwestycje",
            name: "Pod inwestycje",
            url: rpAppLink.investmentOffer.landingPage(),
            position: "2"
        },
        /*
         * `InvestmentOfferTypeSlug.INVESTMENT` is a fake type - it cannot be chosen from filters.
         * For this type we don't have `matchedCategoryObject` even if `category` is defined.
         * We need to add breadcrumb directly for this type.
         */
        ...(!!category && !matchedCategoryObject && category === InvestmentOfferTypeSlug.INVESTMENT
            ? [
                  {
                      key: "apartamenty-inwestycyjne",
                      name: "Apartamenty inwestycyjne",
                      url: rpAppLink.investmentOffer.investmentCategory.base({category: category}),
                      position: "3"
                  }
              ]
            : []),
        ...(!!category && !!matchedCategoryObject
            ? [
                  {
                      key: matchedCategoryObject.namePlural,
                      name: matchedCategoryObject.namePlural,
                      url: rpAppLink.investmentOffer.investmentCategory.base({category: category}),
                      position: "3"
                  }
              ]
            : []),
        ...(!!category && !!subcategory && !!matchedSubcategoryObject
            ? [
                  {
                      key: matchedSubcategoryObject.name,
                      name: matchedSubcategoryObject.name,
                      url: rpAppLink.investmentOffer.investmentCategory.subcategory.base({
                          category: category,
                          subcategory: subcategory
                      }),
                      position: "4"
                  }
              ]
            : [])
    ];
};
import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {
    allInvestmentOfferTypes,
    investmentOfferCities,
    investmentOfferCountries,
    investmentOfferHolidayTypes,
    InvestmentOfferTypeSlug
} from "../constants/investment_offer_constants";

export const useInvestmentOfferListBreadcrumbs = () => {
    const categories = useSelector((state: IRPStore) => state.investmentOffer.categories);

    const {category, subcategory} = categories;

    const matchedCategoryObject = category && allInvestmentOfferTypes.find((type) => type.slug === category);
    const matchedSubcategoryObject =
        subcategory && [...investmentOfferCities, ...investmentOfferHolidayTypes, ...investmentOfferCountries].find((type) => type.slug === subcategory);

    return [
        {
            key: "pod-inwestycje",
            name: "Pod inwestycje",
            url: rpAppLink.investmentOffer.landingPage(),
            position: "2"
        },
        /*
         * `InvestmentOfferTypeSlug.INVESTMENT` is a fake type - it cannot be chosen from filters.
         * For this type we don't have `matchedCategoryObject` even if `category` is defined.
         * We need to add breadcrumb directly for this type.
         */
        ...(!!category && !matchedCategoryObject && category === InvestmentOfferTypeSlug.INVESTMENT
            ? [
                  {
                      key: "apartamenty-inwestycyjne",
                      name: "Apartamenty inwestycyjne",
                      url: rpAppLink.investmentOffer.investmentCategory.base({category: category}),
                      position: "3"
                  }
              ]
            : []),
        ...(!!category && !!matchedCategoryObject
            ? [
                  {
                      key: matchedCategoryObject.namePlural,
                      name: matchedCategoryObject.namePlural,
                      url: rpAppLink.investmentOffer.investmentCategory.base({category: category}),
                      position: "3"
                  }
              ]
            : []),
        ...(!!category && !!subcategory && !!matchedSubcategoryObject
            ? [
                  {
                      key: matchedSubcategoryObject.name,
                      name: matchedSubcategoryObject.name,
                      url: rpAppLink.investmentOffer.investmentCategory.subcategory.base({
                          category: category,
                          subcategory: subcategory
                      }),
                      position: "4"
                  }
              ]
            : [])
    ];
};
